import { Menu, X } from 'lucide-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center gap-3">
              <img 
                src="https://res.cloudinary.com/dg14vitlg/image/upload/v1739297865/BNC%20Africa/qvx3hwkfu0ey9nu2mctb.png"
                alt="BNC Africa Holdings Logo"
                className="w-10 h-10 object-contain"
              />
              <span className="text-xl font-bold text-gray-900">BNC Africa Holdings Group Limited</span>
            </Link>
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-gray-800 hover:text-brown-600">Home</Link>
            <Link to="/about" className="text-gray-800 hover:text-brown-600">About</Link>
            <Link to="/subsidiaries" className="text-gray-800 hover:text-brown-600">Subsidiaries</Link>
            <Link to="/careers" className="text-gray-800 hover:text-brown-600">Careers</Link>
            <Link to="/contact" className="text-gray-800 hover:text-brown-600">Contact</Link>
          </div>

          <div className="md:hidden flex items-center">
            <button 
              onClick={() => setIsOpen(!isOpen)} 
              className="text-gray-800 hover:text-brown-600 focus:outline-none focus:ring-2 focus:ring-brown-600 focus:ring-offset-2 rounded-md p-2"
              aria-label="Toggle menu"
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {isOpen && (
        <div className="md:hidden">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            <Link to="/" className="block px-3 py-2 text-gray-800 hover:text-brown-600">Home</Link>
            <Link to="/about" className="block px-3 py-2 text-gray-800 hover:text-brown-600">About</Link>
            <Link to="/subsidiaries" className="block px-3 py-2 text-gray-800 hover:text-brown-600">Subsidiaries</Link>
            <Link to="/careers" className="block px-3 py-2 text-gray-800 hover:text-brown-600">Careers</Link>
            <Link to="/contact" className="block px-3 py-2 text-gray-800 hover:text-brown-600">Contact</Link>
          </div>
        </div>
      )}
    </nav>
  );
}